var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChristmasXLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8541 12.703L29.0223 0H26.3758L16.6784 11.0298L8.9332 0H0L11.7123 16.679L0 30H2.64665L12.8873 18.3522L21.0668 30H30L17.8534 12.703H17.8541ZM14.2291 16.8259L13.0424 15.1651L3.60028 1.94952H7.66537L15.2853 12.6149L16.472 14.2758L26.377 28.1391H22.3119L14.2291 16.8266V16.8259Z",
    fill: "#DFBA5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasXLogo);
export default __webpack_public_path__ + "static/media/christmas_x_logo.0a73bceaea8e97203af88c267d2525eb.svg";
export { ForwardRef as ReactComponent };